import { reportException } from "utils/errorReporting";

import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        // TODO: do something with errorInfo
        reportException(error);
    }

    render() {
        const { fallback, children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return fallback || null;
        }

        return children;
    }
}
